module.exports = __webpack_public_path__ + "img/employee_avatar.1d06a262.png";